import {
  SET_LOGIN_MESSAGE,
  SET_USER_ID,
  SET_USER_LOGIN_STATUS,
  START_LOGIN_LOADING,
  USER_REGISTRATION,
  SET_USER_EMAIL,
} from "./UserTypes";

const initialstate = {
  userId: "",
  name: "",
  email: "",
  phone: "",
  password: "",
  isLoggedIn: false,
  isLoading: false,
  logInMessage: "",
};

const UserReducer = (state = { initialstate }, action) => {
  switch (action.type) {
    case START_LOGIN_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case SET_LOGIN_MESSAGE:
      return {
        ...state,
        logInMessage: action.payload,
        isLoading: false,
      };
    case SET_USER_ID:
      return {
        ...state,
        userId: action.payload,
      };
    case SET_USER_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case SET_USER_LOGIN_STATUS:
      return {
        ...state,
        isLoggedIn: action.payload,
        logInMessage: "",
      };
    case USER_REGISTRATION:
      return {
        ...state,
        name: action.name,
        email: action.email,
        phone: action.phone,
        password: action.password,
      };
    default:
      return state;
  }
};

export default UserReducer;
